var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("patchesController", [
    "$scope",
    "$window",
    "productService",
    "configs",
    function ($scope, $window, productService, configs) {
        $scope.windowWidth = $window.innerWidth;
        $scope.categories = [];
        $scope.samples = [];
        $scope.samplesMaster = [];
        $scope.showCat = false;
        $scope.faq_activeIndex = 0;

        $scope.toggleAnswer = function (index) {
            $scope.faq_activeIndex = $scope.faq_activeIndex === index ? -1 : index;
        };

        $scope.getPatchesCategories = function () {
            productService.getPatchesCategories().then(function (response) {
                $scope.categories = response.data;
                $scope.showCat = true;
            })
        };

        $scope.getPatchContent = function () {
            productService.getPatchContent().then(function (response) {
                if (response && response.data) {
                    $scope.questions = response.data.FAQ;
                    $scope.patchSamplesMaster = response.data.Samples;
                    $scope.getActivePatches();
                    angular.element($window).bind("resize", function () {
                        $scope.windowWidth = $window.innerWidth;
                        $scope.getActivePatches();
                    });
                }
            })
        }

        $scope.getPatchContent ();
        $scope.getPatchesCategories();

        $scope.getCategoryLink = function (cat) {
            if (cat != null) {
                return "/themes/patch/" + cat.categoryName.replace(/ /g, "-");
            }
        }

        $scope.getCategoryImage = function (cat) {
            if (cat != null) {
                return window.__env.imageFileLocation + "category_icons/" + cat.categoryName.replace(/ /g, "-").toLowerCase() + ".jpg";
            }
        }

        $scope.getPatchActiveCarousalLength = function (from) {
            if ($scope.windowWidth > 991) {
                return 5;
            } else if ($scope.windowWidth < 575) {
                return 3;
            } else {
                return 4;
            }
        };

        $scope.getActivePatches = function () {
            if (angular.isDefined($scope.patchSamplesMaster) && $scope.patchSamplesMaster.length > 0) {
                $scope.activePatchIndex = $scope.getPatchActiveCarousalLength() - 1;
                $scope.patchSamples = $scope.patchSamplesMaster.slice(0, $scope.getPatchActiveCarousalLength());
            }
        };

        $scope.onPatchNavClick = function (navOption) {
            switch (navOption) {
                case "prev":
                    if ($scope.activePatchIndex - $scope.getPatchActiveCarousalLength() + 1 > 0) {
                        $scope.activePatchIndex = $scope.activePatchIndex - 1;
                        $scope.patchSamples.pop();
                        $scope.patchSamples.unshift(
                            $scope.patchSamplesMaster[
                            $scope.activePatchIndex - $scope.getPatchActiveCarousalLength() + 1
                            ]
                        );
                    }
                    break;
                default:
                    if ($scope.activePatchIndex < $scope.patchSamplesMaster.length - 1) {
                        $scope.activePatchIndex = $scope.activePatchIndex + 1;
                        $scope.patchSamples.splice(0, 1);
                        $scope.patchSamples.push($scope.patchSamplesMaster[$scope.activePatchIndex]);
                    }
                    break;
            }
        };
    },
]);
